var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShopbot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 399.471 331.592",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "204.176 141.5 204.176 42.315 210.349 45.987 210.349 145.173 204.176 141.5",
    fill: "#13153c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.416 46.026 231.535 33.833 231.506 133.002 210.388 145.195 210.416 46.026",
    fill: "#212866"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.416 46.026 231.535 33.833 225.321 30.136 204.202 42.329 210.416 46.026",
    fill: "#f2e9e4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "22.592 246.409 22.592 147.223 28.765 150.895 28.765 250.081 22.592 246.409",
    fill: "#13153c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "28.832 150.934 49.951 138.741 49.922 237.91 28.803 250.103 28.832 150.934",
    fill: "#212866"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "28.832 150.934 49.951 138.741 43.736 135.045 22.617 147.238 28.832 150.934",
    fill: "#f2e9e4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "251.112 15.266 0 160.246 6.267 163.756 257.379 18.776 251.112 15.266",
    fill: "#dbd2c8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "6.334 163.795 6.334 188.181 257.418 43.184 257.418 18.798 6.334 163.795",
    fill: "#979893"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "6.334 163.795 6.334 188.181 .026 184.647 .026 160.261 6.334 163.795",
    fill: "#f2e9e4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "164.304 327.898 164.304 228.712 170.477 232.384 170.477 331.57 164.304 327.898",
    fill: "#13153c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.545 232.423 191.663 220.23 191.635 319.399 170.516 331.592 170.545 232.423",
    fill: "#212866"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.545 232.423 191.663 220.23 185.449 216.534 164.33 228.727 170.545 232.423",
    fill: "#f2e9e4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "345.889 222.989 345.889 123.803 352.062 127.476 352.062 226.662 345.889 222.989",
    fill: "#13153c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.129 127.515 373.248 115.322 373.219 214.491 352.1 226.684 352.129 127.515",
    fill: "#212866"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.129 127.515 373.248 115.322 367.033 111.625 345.914 123.818 352.129 127.515",
    fill: "#f2e9e4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "257.117 27.614 6.005 172.593 142.053 251.033 393.166 106.053 257.117 27.614",
    fill: "#ffcfae"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.121 251.072 142.121 257.827 393.204 112.831 393.204 106.075 142.121 251.072",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.121 251.072 142.121 257.827 6.031 179.364 6.031 172.608 142.121 251.072",
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "393.166 97.238 142.053 242.217 148.32 245.727 399.433 100.747 393.166 97.238",
    fill: "#dbd2c8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.388 245.766 148.388 270.152 399.471 125.156 399.471 100.77 148.388 245.766",
    fill: "#979893"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.388 245.766 148.388 270.152 142.079 266.618 142.079 242.232 148.388 245.766",
    fill: "#f2e9e4"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "140.857 80.395 140.857 8.792 145.313 11.443 145.313 83.047 140.857 80.395",
    fill: "#13153c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.362 11.471 160.608 2.668 160.587 74.26 145.341 83.063 145.362 11.471",
    fill: "#212866"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.362 11.471 160.608 2.668 156.121 0 140.875 8.802 145.362 11.471",
    fill: "#f2e9e4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "140.89 62.952 114.308 78.346 118.833 80.88 145.414 65.486 140.89 62.952",
    fill: "#13153c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.761 87.157 98.618 110.043 160.608 74.229 160.608 56.625 107.761 87.157",
    fill: "#212866"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "94.045 107.376 124.979 17.892 129.436 20.543 98.501 110.027 94.045 107.376",
    fill: "#f2e9e4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.484 20.571 144.73 11.769 113.775 101.241 98.529 110.043 129.484 20.571",
    fill: "#212866"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.484 20.571 144.73 11.769 140.244 9.1 124.998 17.902 129.484 20.571",
    fill: "#13153c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "156.056 0 124.614 18.169 129.139 20.703 160.58 2.534 156.056 0",
    fill: "#f2e9e4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.187 20.731 129.187 38.336 160.608 20.154 160.608 2.55 129.187 20.731",
    fill: "#212866"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "146.569 10.478 284.772 89.506 278.505 93.016 140.303 13.988 146.569 10.478",
    fill: "#dbd2c8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.438 93.055 278.438 117.44 140.264 38.396 140.264 14.01 278.438 93.055",
    fill: "#979893"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.438 93.055 278.438 117.44 284.746 113.907 284.746 89.521 278.438 93.055",
    fill: "#f2e9e4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "281.007 162.524 281.007 90.92 285.463 93.571 285.463 165.175 281.007 162.524",
    fill: "#13153c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.512 93.6 300.758 84.797 300.737 156.389 285.491 165.191 285.512 93.6",
    fill: "#212866"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.512 93.6 300.758 84.797 296.272 82.129 281.026 90.931 285.512 93.6",
    fill: "#f2e9e4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "281.04 145.081 254.459 160.475 258.983 163.008 285.564 147.615 281.04 145.081",
    fill: "#13153c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.911 169.285 238.768 192.172 300.758 156.358 300.758 138.754 247.911 169.285",
    fill: "#212866"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "234.195 189.505 265.129 100.02 269.586 102.672 238.652 192.156 234.195 189.505",
    fill: "#f2e9e4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.635 102.7 284.88 93.897 253.926 183.37 238.68 192.172 269.635 102.7",
    fill: "#212866"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.635 102.7 284.88 93.897 280.394 91.229 265.148 100.031 269.635 102.7",
    fill: "#13153c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "296.206 82.129 264.765 100.298 269.289 102.832 300.73 84.663 296.206 82.129",
    fill: "#f2e9e4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.337 102.86 269.337 120.465 300.758 102.283 300.758 84.679 269.337 102.86",
    fill: "#212866"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M181.219,105.878l.234,6.458c.06,1.65,.977,3.15,2.419,3.954l18.711,10.44c1.452,.81,3.223,.797,4.664-.034l11.555-6.671c1.353-.781,2.232-2.181,2.349-3.738l.479-6.4-30.011-5.906-10.4,1.898Z",
    fill: "#415150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.468,108.657l-25.442-10.83c-.573-.244-1.23-.207-1.758,.097l-11.168,6.448c-1.236,.714-1.161,2.441,.135,3.102l23.465,11.971c.597,.304,1.313,.289,1.882-.039l13.145-7.589c1.289-.744,1.139-2.565-.259-3.16Z",
    fill: "#2f3a3b"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M207.716,111.101c-4.612,2.662-11.587,2.952-15.581,.646-1.653-.954-2.534-2.204-2.674-3.529h0c-.026-.243-.026-.488-.002-.735l-.068-24.432,22.087-1.799,.042,24.506c.012,.166,.012,.333,0,.5v.002s0,0,0,0c-.115,1.693-1.399,3.452-3.804,4.841Z",
    fill: "#4d5a5c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.434,
    cy: 82.215,
    rx: 11.101,
    ry: 6.28,
    transform: "translate(-8.474 24.853) rotate(-6.949)",
    fill: "#2f3a3b"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.613,
    cy: 81.018,
    rx: 7.108,
    ry: 4.559,
    transform: "translate(-2.847 7.442) rotate(-2.11)",
    fill: "#03070a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.233,
    cy: 70.008,
    rx: 7.107,
    ry: 6.796,
    transform: "translate(-7.57 27.435) rotate(-7.693)",
    fill: "#03070a"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.333 69.82 193.132 70.195 193.513 81.442 207.714 81.067 207.333 69.82",
    fill: "#03070a"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.687,
    cy: 67.956,
    rx: 9.458,
    ry: 9.045,
    transform: "translate(-7.269 27.364) rotate(-7.662)",
    fill: "#566164"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.981,
    y: 48.118,
    width: 18.906,
    height: 19.841,
    transform: "translate(-1.459 5.3) rotate(-1.509)",
    fill: "#566164"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.196,
    cy: 48.756,
    rx: 9.481,
    ry: 7.038,
    transform: "translate(-1.848 8.338) rotate(-2.375)",
    fill: "#6b7577"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "218.767 80.629 228.521 75.219 228.521 49.532 218.767 54.943 218.767 80.629",
    fill: "#2e383c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.851 32.984 189.605 27.574 228.521 49.853 218.767 55.263 179.851 32.984",
    fill: "#465152"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.767 80.629 179.831 58.53 179.831 32.844 218.767 54.943 218.767 80.629",
    fill: "#8c9292"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopbot);
export default __webpack_public_path__ + "static/media/shopbot.9b67d9c0e59f37324067ed1b317dabdb.svg";
export { ForwardRef as ReactComponent };